import React, { } from "react";
import RenderComponent from "../../../General/RenderComponent";
import WhiteSpaceChartContainer from "./WhiteSpaceChartContainer";

const WhiteSpaceChartsDisplay = React.forwardRef(({
    setDisabledDownload = () => { },
    loading,
    showZeroInChart
}, ref) => {
    return (
        <RenderComponent
            isFullscreen
            loadingProps={{
                loading,
                description: "Loading Charts. Please wait..."
            }}
        >
            <WhiteSpaceChartContainer
                showZeroInChart={showZeroInChart}
                ref={ref}
                setDisabledDownload={setDisabledDownload}
            />
        </RenderComponent>
    );
})

export default WhiteSpaceChartsDisplay;
